<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Step 3 of 4</div>
        </md-card-header>
        <div class="md-title">
          Please take a photo of your government issued ID
          <a @click="showDialog = true">(?)</a> <br />
        </div>

        <div class="md-title">The ID must have your name & photo on it.</div>
        <br />
        <div class="md-title">
          Be sure the ID is on a table and in good light so we can validate it.
        </div>
        <br />
        <div class="md-title">Please ensure none of the ID is cut off.</div>
        <md-card-actions>
          <md-button @click="TakePhoto" class="md-primary">Next</md-button>
        </md-card-actions>
      </md-card>
    </form>
    <md-dialog :md-active.sync="showDialog" class="dialog">
      <md-dialog-title>Preferences</md-dialog-title>
      <div class="text_content">
        <h4>
          You can use any government issued ID, so long as it has a
          <br />
          photo of your face on it. Some examples:
        </h4>
        <div class="text_content">
          <p>
            • Drivers Licence<br />
            • Passport<br />
            • Govt ID card<br />
            • Social Security card<br />
            • Military ID card
          </p>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          >Close</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";

export default {
  name: "TakePhotoPrepare",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      sixcode: null,
    },
    showDialog: false,
  }),

  mounted() {},
  methods: {
    TakePhoto() {
        this.$router.push({ name: "TakePhoto"});
    },
    saveUser() {},
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.md-card-actions {
  flex-direction: column;
}

.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.text_content {
  padding: 10px;
}
.footer {
  margin-top: 20px;
  padding: 10px;
  font-size: 120%;
}

.md-card {
  display: inline-block;
  padding: 20px;
  width:500px;
}

.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}

.md-layout-item.md-size-50 {
  min-width: 80%;
  max-width: 70%;
} */
</style>
